/* eslint-disable no-unused-vars */
export var TemplateBaseName;
(function (TemplateBaseName) {
    TemplateBaseName["WITHOUT_TEMPLATE"] = "\u0428\u0430\u0431\u043B\u043E\u043D \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u0441\u0430";
    TemplateBaseName["STANDARD_FIRST"] = "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 1";
    TemplateBaseName["STANDARD_SECOND"] = "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 2";
})(TemplateBaseName || (TemplateBaseName = {}));
/* eslint-enable no-unused-vars */
